"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.circuitBreaker = exports.CIRCUIT_BREAKER_ERRORS = exports.CIRCUIT_BREAKER_DEFAULTS = void 0;
const timeout_1 = require("./timeout");
const cross_fetch_1 = require("cross-fetch");
const opossum_1 = __importDefault(require("opossum"));
const breakers = new Map();
exports.CIRCUIT_BREAKER_DEFAULTS = {
    enabled: true,
    volumeThreshold: 100,
    resetTimeout: 30 * 1000,
    rollingCountTimeout: 10 * 1000,
    errorThresholdPercentage: 70,
    timeout: timeout_1.DEFAULT_TIMEOUT_MS + 5,
    // is the response ok from CB perspective? should ignore this error in stats?
    errorFilter: (err) => {
        if ("response" in err) {
            const status = err.response.status;
            return status > 0 && status < 500;
        }
        return false;
    },
};
var CIRCUIT_BREAKER_ERRORS;
(function (CIRCUIT_BREAKER_ERRORS) {
    CIRCUIT_BREAKER_ERRORS[CIRCUIT_BREAKER_ERRORS["ETIMEDOUT"] = 504] = "ETIMEDOUT";
    CIRCUIT_BREAKER_ERRORS[CIRCUIT_BREAKER_ERRORS["EOPENBREAKER"] = 503] = "EOPENBREAKER";
    CIRCUIT_BREAKER_ERRORS[CIRCUIT_BREAKER_ERRORS["ESEMLOCKED"] = 429] = "ESEMLOCKED";
    CIRCUIT_BREAKER_ERRORS[CIRCUIT_BREAKER_ERRORS["ESHUTDOWN"] = 423] = "ESHUTDOWN";
    CIRCUIT_BREAKER_ERRORS[CIRCUIT_BREAKER_ERRORS["UNKNOWN"] = 418] = "UNKNOWN";
})(CIRCUIT_BREAKER_ERRORS = exports.CIRCUIT_BREAKER_ERRORS || (exports.CIRCUIT_BREAKER_ERRORS = {}));
// use list of sorted options as key to vary CB based on all of them
const getBreakerId = (options) => {
    return Object.keys(options)
        .sort()
        .map(key => options[key])
        .join("|");
};
// the internal handler that is called within breaker.fire method
const handler = (ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    yield next();
    if (ctx.response && !((_b = (_a = ctx.options.circuitBreaker) === null || _a === void 0 ? void 0 : _a.errorFilter) === null || _b === void 0 ? void 0 : _b.call(_a, ctx))) {
        const err = new Error("Response is not OK");
        Object.defineProperties(err, Object.getOwnPropertyDescriptors(ctx));
        Object.defineProperty(err, "isCBError", { value: true });
        throw err;
    }
});
/**
 * Circuit breaker middleware based on [Opossum](https://nodeshift.dev/opossum/)
 *
 * it behaves the way that it uses one circuit breaker per configuration & service (defined by hostname)
 * so if you are calling same service with 2 different breaker configurations it will create 2 different CBs
 *
 */
const circuitBreaker = (ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
    var _c, _d, _e;
    // short-circuit on client requests
    if (typeof window === undefined)
        return next();
    const url = typeof ctx.input === "string" ? ctx.input : ctx.input.url;
    const name = new URL(url).hostname;
    ctx.options.circuitBreaker = Object.assign(Object.assign(Object.assign({}, exports.CIRCUIT_BREAKER_DEFAULTS), (_c = ctx.options) === null || _c === void 0 ? void 0 : _c.circuitBreaker), { timeout: ctx.options.timeout || exports.CIRCUIT_BREAKER_DEFAULTS.timeout, name });
    const id = getBreakerId(ctx.options.circuitBreaker);
    if (!breakers.has(id)) {
        breakers.set(id, new opossum_1.default(handler, ctx.options.circuitBreaker));
    }
    try {
        yield ((_d = breakers.get(id)) === null || _d === void 0 ? void 0 : _d.fire(ctx, next));
    }
    catch (err) {
        // we want to catch only Circuit Breaker errors
        if (!opossum_1.default.isOurError(err) && !(err === null || err === void 0 ? void 0 : err.isCBError))
            throw err;
        // if circuit breaker throw error but something also set the response ignore the error
        if (ctx.response)
            return;
        const status = (_e = CIRCUIT_BREAKER_ERRORS[err.code]) !== null && _e !== void 0 ? _e : CIRCUIT_BREAKER_ERRORS.UNKNOWN;
        ctx.response = new cross_fetch_1.Response(`{ "message": "${err.code}" }`, {
            status,
            statusText: err.code,
        });
    }
});
exports.circuitBreaker = circuitBreaker;
//# sourceMappingURL=circuitBreaker.js.map